import { IonContent } from '@ionic/react';
import DealsCarousel from '../../../../../components-library/carousel/DealsCarousel';
import Header from './components/header';
import FeaturedPosts from './components/FeaturedPosts/FeaturedPosts';
import MostPopularProducts from '../../../features/shared/components/most-popular-products';
import useDeepRef from '../../../../../hooks/utility/useDeepRef';
import { OrderMethodModalProps } from '../../../../../services/exports/Interfaces';
import { useEffect } from 'react';
import useAppState from '../../../../../hooks/global/useAppState';
import useOrderFlow from '../../../../../hooks/order/useOrderFlow';
import useInitialData from '../../../../../hooks/global/useInitialData';
import useModalRouter from '../../../common/hooks/useModalRouter';
import { Modals } from '../../../exports/Enums';
import PushNotificationAlert from './components/push-notifications/PushNotificationAlert';
import useMobileApp from '../../../../../hooks/mobile-app/useMobileApp';

const HomeTab = () => {
  const { data } = useInitialData();
  const { franchise, company } = data;
  const { isOrderMethodInfoComplete } = useOrderFlow();
  const { orderMethodModalProps } = useAppState();
  const { openModal, isOpen } = useModalRouter();
  const { pushNotificationPopUpOpen } = useMobileApp();
  const orderMethodModalPropsRef = useDeepRef<OrderMethodModalProps>(orderMethodModalProps);
  const isOrderMethodInfoCompleteRef = useDeepRef<boolean>(isOrderMethodInfoComplete);
  const hasLiveOrdersRef = useDeepRef<boolean>(company?.has_live_orders);
  const hasMultipleCompaniesRef = useDeepRef<boolean>(franchise?.has_multiple_companies);
  const pushNotificationPopUpOpenRef = useDeepRef<boolean>(pushNotificationPopUpOpen);

  const initOrderMethodModal = () => {
    if (
      orderMethodModalPropsRef.current.openModal ||
      isOrderMethodInfoCompleteRef.current ||
      !hasLiveOrdersRef.current ||
      pushNotificationPopUpOpenRef.current
    ) {
      return;
    }

    openModal({ id: Modals.OrderMethod, props: { openModal: true } });
  };

  useEffect(() => {
    if (isOpen) {
      return;
    }

    if (
      !isOrderMethodInfoCompleteRef.current &&
      hasMultipleCompaniesRef.current &&
      !pushNotificationPopUpOpenRef.current
    ) {
      const timer = setTimeout(() => initOrderMethodModal(), 4000);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  return (
    <>
      <IonContent fullscreen className="space-y-md [&::part(scroll)]:bg-white [&::part(scroll)]:pb-[140px]">
        <Header />
        <DealsCarousel dealClassName="bg-white border" />
        <MostPopularProducts />
        <FeaturedPosts className="px-md" />
        <PushNotificationAlert />
      </IonContent>
    </>
  );
};

export default HomeTab;
